



<div class="toolbar">
  <div class="inner text-md-right">
    <a class="toolbar-toggle mobile-menu-toggle" href="#mobileMenu">
      <!-- <i class="material-icons menu"></i> -->
      <span><i class="fa fa-bars" aria-hidden="true"></i></span>
    </a>

    <app-booking-queue-indicator></app-booking-queue-indicator>

    <app-rental-overdue-bell></app-rental-overdue-bell>

    <a class="toolbar-toggle set-settings" data-bs-toggle="tooltip" title="Settings" data-original-title="Settings" (click)="settings()">
      <!-- <i style="font-size:25px;" class="material-icons settings "></i> -->
      <span><i class="fa fa-cog" aria-hidden="true"></i></span>
    </a>

    <!-- <a class="toolbar-toggle set-settings" routerLink="/app/stoda/online-pooja-enquiry" data-bs-toggle="tooltip" title="" data-original-title="Online Pooja Enquiry">
      <i style="font-size:25px;" class="material-icons visibility"></i>
    </a> -->
    <a *ngIf="!!obj.isOnlineSync" class="toolbar-toggle set-settings" data-bs-toggle="tooltip" title="Online Synchronization" data-original-title="Online Synchronization" (click)="onlineSynchronization()">
      <!-- <i style="font-size:25px;" class="material-icons sync "></i> -->
      <span><i class="fa fa-refresh" aria-hidden="true"></i></span>
    </a>
    <a class="toolbar-toggle set-settings" data-bs-toggle="tooltip" title="Logout" data-original-title="Logout" (click)="logOut()">
      <!-- <i style="font-size:25px;" class="material-icons power_settings_new "></i> -->
      <span><i class="fa fa-sign-out" aria-hidden="true"></i></span>
    </a>

  </div>
 <!-- <h5 style="color:#5D6D7E;">Welcome {{obj.firstName}} {{obj.lastName}} !</h5>  -->
  <div class="toolbar-dropdown">
    <app-mobile-menu></app-mobile-menu>
  </div>
</div>
